<section [appStoryblok]="_editable()" class="featured" aria-labelledby="featured-title">
    <div class="featured-heading">
        <h1 id="featured-title" class="ui-heading-1">{{title()}}</h1>
        <p class="ui-body-l">{{subtitle()}}</p>             
    </div>

    <div class="featured-carousel" #carouselContainer role="region" aria-roledescription="carousel">
        <div class="carousel-items" #carousel 
             (mousedown)="onDragStart($event)" 
             (mousemove)="onDragMove($event)" 
             (mouseup)="onDragEnd()"
             (mouseleave)="onDragEnd()">
        
             @for(c of content(); track c._uid) {
                @if (components[c.component]) {
                    <ndc-dynamic [ndcDynamicComponent]="components[c.component]" [ndcDynamicInputs]="c">
                    </ndc-dynamic>
                } @else {
                    <ndc-dynamic [ndcDynamicComponent]="components['notImplemented']" [ndcDynamicInputs]="c">
                    </ndc-dynamic>
                }
            }
        </div>
    </div>


    
    <div class="featured-arrows-navigation">
        @if(iconLeft()) {
            <button rds-icon-button size="m" (click)="scrollToLeft()" tabindex="-1" aria-label="Scroll left">
                <rds-icon namespace="filled" [icon]="iconLeft()"/>
            </button>
        }

        @if(iconRight()) {
            <button rds-icon-button size="m" (click)="scrollToRight()" tabindex="-1" aria-label="Scroll right">
                <rds-icon namespace="filled" [icon]="iconRight()"/>
            </button>
        }
    </div>
    
</section>